export default __webpack_public_path__ + "static/media/char_body_002.52efe0c0.png";